import type { SVGProps } from "react";
import React from "react";

export const CloseIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  fill = "#000",
  width = 24,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.35355 5.64645C6.15829 5.45118 5.84171 5.45118 5.64645 5.64645C5.45118 5.84171 5.45118 6.15829 5.64645 6.35355L11.2529 11.96L5.64645 17.5664C5.45118 17.7617 5.45118 18.0783 5.64645 18.2736C5.84171 18.4688 6.15829 18.4688 6.35355 18.2736L11.96 12.6671L17.5664 18.2736C17.7617 18.4688 18.0783 18.4688 18.2736 18.2736C18.4688 18.0783 18.4688 17.7617 18.2736 17.5664L12.6671 11.96L18.2736 6.35355C18.4688 6.15829 18.4688 5.84171 18.2736 5.64645C18.0783 5.45118 17.7617 5.45118 17.5664 5.64645L11.96 11.2529L6.35355 5.64645Z"
    />
  </svg>
);
